import cn from "classnames";
import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { dateToView } from "helpers/date";
import { organizationFlags, organizationFlagsEnum } from "helpers/enums";
import { connect } from "helpers/redux";
import { flagVal } from "helpers/system";
import camelCase from "lodash/camelCase";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { apply } from "sources/books/logisticSalary";
import { download, getItem } from "sources/books/reports";
import { Filter, Table } from "./partials";
import tableCells from "./tableCells";

const useOdometerMileageFlagVal = flagVal(organizationFlags, organizationFlagsEnum.UseOdometerMileage);

const toggleDefaultValues = {
    baseValues: true,
    indicators: true,
    salaries: true,
    salaryCostOption: true,
};

const defaultFilterData = {
    year: moment().year(),
    month: moment().format("MM"),
};

const ShowCalculationSalaries = (props) => {
    const [filter, setFilter] = useState(defaultFilterData);
    const [updateData, setUpdateData] = useState({});
    const [dataTable, setDataTable] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [openedDropd, setOpenedDropd] = useState(false);
    const [opened, setOpened] = useState(toggleDefaultValues);
    const [period, setPeriod] = useState("");

    useEffect(() => {
        getList();
    }, []);

    const { title, organization } = props;
    const { columns } = dataTable;

    const id = "LogisticSalaryReport";

    const isUpdated = () => {
        const { baseValues, salaryCostOption } = updateData;
        return (baseValues && baseValues.length) || (salaryCostOption && Object.keys(salaryCostOption).length);
    };

    const getList = () => {
        const { year, month } = filter;
        const period = `${year}-${month}-01T00:00:00.00Z`;
        setPeriod(period);
        const params = {
            id,
            reportPeriod: period,
        };
        setIsLoading(true);
        return (isUpdated() ? apply({ ...updateData, period }) : Promise.resolve()).then(() => {
            setUpdateData({ baseValues: [], salaryCostOption: null });
            getItem(params).then((res) => {
                const data = res.data[0];
                setDataTable({ ...res, data });
                setIsLoading(false);
            });
        });
    };

    const setValue = ({ tableName, logistId, name, value }) => {
        const formatFloat = (val) =>
            typeof val === "string" ? parseFloat(val.replace(/[^0-9.,]/g, "").replace(",", ".")) : val;
        const current = dataTable.data[tableName];
        let update = updateData[tableName];
        if (Array.isArray(current)) {
            const findData = current.find((el) => el.logistId === logistId);
            const findUpdateData = update.find((el) => el.logistId === logistId);
            findData[name] = value;
            findUpdateData
                ? (findUpdateData[name] = formatFloat(value))
                : update.push({ ...findData, [name]: formatFloat(value) });
        } else {
            current[name] = value;
            update = { ...current, [name]: value };
            Object.keys(update).forEach((key) => {
                update[key] = formatFloat(update[key]);
            });
        }
        setDataTable({ ...dataTable, data: { ...dataTable.data, [tableName]: current } });
        setUpdateData({ ...updateData, [tableName]: update });
    };

    const dropdActions = () => {
        const actions = [{ text: "Скачать", action: downloadExcel }];
        return actions;
    };

    const downloadExcel = () => {
        setIsLoading(true);
        const fileName = `${title}_${dateToView(period)}.xlsx`;
        const params = {
            id,
            reportPeriod: period,
            fileName,
        };
        return download(params).then(() => setIsLoading(false));
    };

    const renderDropd = () => {
        return (
            openedDropd && (
                <ul className="c-dropd__list no-bullet">
                    {dropdActions().map((item, i) => (
                        <li key={i} className="c-dropd__list-item" onClick={item.action}>
                            {item.text}
                        </li>
                    ))}
                </ul>
            )
        );
    };

    const openDropd = () => {
        if (openedDropd) {
            return;
        }
        setOpenedDropd(true);
        setTimeout(() => document.addEventListener("click", closeDropd), 0);
    };

    const closeDropd = () => {
        setOpenedDropd(false);
        document.removeEventListener("click", closeDropd);
    };

    const toggleTable = (tableName) => setOpened({ ...opened, [tableName]: !opened[tableName] });

    const toggleHeaderText = (tableName) =>
        cn("b-filter__search-text", {
            "b-filter__search-text--dark font-weight-bold": opened[tableName],
        });

    const toggleExpand = (tableName) =>
        cn("b-filter__collapse-btn", {
            "b-filter__collapse-btn--top": opened[tableName],
            "b-filter__collapse-btn--bottom": !opened[tableName],
        });

    const useOdometerMileageEnabled = (organization.intFlags & useOdometerMileageFlagVal) === useOdometerMileageFlagVal;
    const additionalText = "(пробег рассчитан на основе одометра)";

    return (
        <Transition dir="full">
            <div className="page-book__show book-show">
                <div className="book-show__head">
                    <div className="book-show__close close close--sm" onClick={props.back} />
                    <div className="book-show__title">
                        {title}
                        &nbsp;
                        {useOdometerMileageEnabled && <small>{additionalText}</small>}
                    </div>
                    {!!dropdActions().length && (
                        <div className="book-show__dropdown c-dropd">
                            <div className="c-dropd__btn" onClick={openDropd} />
                            {renderDropd()}
                        </div>
                    )}
                </div>
                <Filter getList={getList} filter={filter} setFilter={setFilter} />
                <div className="book-show__body--calculationSalaries">
                    {isLoading ? (
                        <div className="loader-snippet--disable-loader">
                            <Loader />
                        </div>
                    ) : (
                        <>
                            {columns.map((column, index) => {
                                const { label, propertyName } = column;
                                const tableName = camelCase(propertyName);
                                const headerTextCname = toggleHeaderText(tableName);
                                const expandCname = toggleExpand(tableName);
                                const cell = tableCells(organization?.currencyData?.name)[tableName];
                                const tableProps = {
                                    ...cell,
                                    data: dataTable.data[tableName],
                                    tableName,
                                    setValue,
                                };
                                return (
                                    <div className="b-filter mb-2" key={index}>
                                        <div className="b-filter__head" onClick={() => toggleTable(tableName)}>
                                            <div className="b-filter__head--left ml-1">
                                                <div className={headerTextCname}>{label}</div>
                                            </div>
                                            <div className="b-filter__head--right">
                                                <div className={expandCname} />
                                            </div>
                                        </div>
                                        {opened[tableName] && <Table {...tableProps} />}
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            </div>
        </Transition>
    );
};

function container(Component) {
    const mapState = (state) => ({
        organization: state.profile.organization,
    });
    const mapDispatch = () => ({});
    return connect(mapState, mapDispatch)(Component);
}

export default container(ShowCalculationSalaries);
